import React from "react";
import { Outlet } from "react-router-dom";
import { usePortalAuth } from "../auth/PortalAuthContext";

export function PortalShell() {
  const { account, logout } = usePortalAuth();

  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh", background: "var(--color-bg)" }}>
      <header
        className="d-flex align-items-center gap-4 px-4"
        style={{ height: 55, background: "var(--sp-navbar)", color: "#fff" }}
      >
        <div className="d-flex align-items-center gap-2">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ width: 28, height: 28, borderRadius: 8, background: "rgba(255,255,255,.14)" }}
          >
            <span style={{ fontSize: 13, fontWeight: 700 }}>SP</span>
          </div>
          <span style={{ fontSize: 14 }}>Portal do cliente</span>
        </div>

        <div className="ms-auto d-flex align-items-center gap-3">
          <span style={{ fontSize: "0.85rem", color: "#dddddd" }}>{account?.customer.razaoSocial}</span>
          <button
            type="button"
            style={{
              fontSize: "0.85rem",
              padding: "0.3rem 0.75rem",
              background: "transparent",
              color: "#fff",
              border: "1px solid rgba(255,255,255,.65)",
              borderRadius: "0.375rem",
              cursor: "pointer",
            }}
            onClick={() => logout()}
          >
            Sair
          </button>
        </div>
      </header>

      <main className="flex-grow-1" style={{ padding: "var(--space-3)" }}>
        <div
          style={{
            maxWidth: 820,
            margin: "0 auto",
            background: "var(--color-page)",
            borderRadius: "var(--radius-md)",
            boxShadow: "var(--shadow-sm)",
            padding: "var(--space-4) var(--space-3)",
          }}
        >
          <Outlet />
        </div>
      </main>
    </div>
  );
}
